import React, { useState, useEffect } from 'react'
import DashboardBlock from './dashboardwidgetsblock';



export default function ApprovedViolation({ violationData, totalCount,loading}) {
    const [amount, setAmount] = useState(0);
    const [approvedcases, setApprovedCases] = useState(0);

    useEffect(() => {
        const data = violationData ? violationData.filter(e => e.status === 'Accept') : [];
        if (data.length > 0) {
            setApprovedCases(0);
            setAmount(0);
            var value = 0
            var valueAmt = 0
            data.forEach(element => {
              value +=  element.cases
              valueAmt += element.sumAmount
            });
            setApprovedCases(value);
            setAmount(valueAmt);
        } else {
            setApprovedCases(0);
            setAmount(0);
        }
    }, [violationData]);


    return (
        <DashboardBlock
            classname="violence-block"
            title="Approved Violations"
            count={approvedcases}
            total={totalCount}
            amount={amount}
            loader={loading} />
    )
}
